var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.23077 8C1.23077 11.7385 4.26146 14.7692 8 14.7692C11.7385 14.7692 14.7692 11.7385 14.7692 8C14.7692 4.26146 11.7385 1.23077 8 1.23077C4.26146 1.23077 1.23077 4.26146 1.23077 8ZM7.38462 11.2821C7.38462 10.9422 7.66013 10.6667 8 10.6667C8.33987 10.6667 8.61539 10.9422 8.61539 11.2821C8.61539 11.6219 8.33987 11.8974 8 11.8974C7.66013 11.8974 7.38462 11.6219 7.38462 11.2821ZM7.38462 8.82051V4.71795C7.38462 4.37808 7.66013 4.10256 8 4.10256C8.33987 4.10256 8.61539 4.37808 8.61539 4.71795V8.82051C8.61539 9.16038 8.33987 9.4359 8 9.4359C7.66013 9.4359 7.38462 9.16038 7.38462 8.82051Z",
    fill: "#EF5E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.84f92400e6a1ef1fe483f835f9be8bce.svg";
export { ForwardRef as ReactComponent };